export default "__VITE_ASSET__BBVCuhvN__"